import get from 'lodash/get';

export function getClickHandler(onClick, onDblClick, options) {
  var timeoutID = null;
  let delay = options || 250;
  
  return function ({ event, rowData }) {
    let canDoubleClick = true;
    if (event?.target.nodeName === "INPUT") return;

    if (typeof options !== "number") {
      delay = options.delay || 250;
      canDoubleClick = options.canDoubleClick?.() ?? true;
    }


    if (!canDoubleClick) {
      if (timeoutID) return;

      onClick({ rowData });
      timeoutID = setTimeout(() => { timeoutID = null; }, delay);
      return;
    }

    if (!timeoutID) {
      timeoutID = setTimeout(function () {
        onClick({ rowData });
        timeoutID = null
      }, delay);
      event?.persist() 
    } else {
      timeoutID = clearTimeout(timeoutID);
      onDblClick?.({ rowData });
    }
  };
}


export function getColumnId(column) {
  return column.name
}

export function deriveHiddenColumns(columns, data) {
  return columns.filter((column) => {
    const accessor = getAccessor(column);
    return column.autoHide && !data.some(datum => get(datum, accessor))
  }).map(getColumnId);
}

export function getAccessor(column) {
  return `${column.name}.rendered`
}